import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { coverageWidgetSetupGroupingSelector } from "@/store/dashboards/selectors/setups/coverage/coverageWidgetSetupGroupingSelector";
import { CoverageGrouping } from "@/services/cloudchipr.api";
import { coverageWidgetSetupDataChangeThunk } from "@/store/dashboards/thunks/widgets/coverage-widget/setup-change/coverageWidgetSetupDataChangeThunk";
import { CoverageWidgetGroupBySelect } from "@/components/pages/dashboard/components/widgets/coverage/components/CoverageWidgetGroupBySelect";

export const CoverageWidgetSetupGroupBySelect: FC = () => {
  const dispatch = useAppDispatch();

  const grouping = useAppSelector(coverageWidgetSetupGroupingSelector);

  const handleChange = useCallback(
    (grouping: CoverageGrouping) => {
      dispatch(
        coverageWidgetSetupDataChangeThunk({
          grouping,
        }),
      );
    },
    [dispatch],
  );

  return (
    <CoverageWidgetGroupBySelect grouping={grouping} onChange={handleChange} />
  );
};
